import { render, staticRenderFns } from "./SwapConfirm.vue?vue&type=template&id=9074fee2&"
import script from "./SwapConfirm.vue?vue&type=script&lang=js&"
export * from "./SwapConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports